
function initAgeVerification() {

    if (Cookies.get('AgeVarified') === 'true') {
        document.body.classList.add('varified-age');
        return;
    }

    const containers = document.querySelectorAll('#ProductGridContainer, .collection-product-grid__container');
    if (!containers.length) return;

    containers.forEach(container => {
        container.addEventListener('click', function (e) {
            const trigger = e.target.closest('.popup-age-trigger');
            if (trigger) {
                const parent = trigger.parentNode;
                parent.classList.add('active');
            }

            const confirmBtn = e.target.closest('.age-confirmation__button');
            if (confirmBtn) {
                Cookies.set('AgeVarified', 'true', { expires: 1 });
                document.body.classList.add('varified-age');
            }
        });
    });
}

initAgeVerification();
